<template>
  <div v-if="sizeGuideId && sizeGuideCopy">
    <button
      class="size-guide__button button button--link"
      type="button"
      @click.prevent="openSizeGuide"
    >
      {{ $t('Size guide') }}
    </button>

    <LazyUiDialog
      class="modal-size-guide"
      name="modal-size-guide"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        <span>{{ $t('Size guide') }}</span>
      </template>

      <div class="size-guide__content">
        <slot name="content">
          <StrapiBlocksText
            v-for="copy in sizeGuideCopy"
            :key="copy"
            :nodes="copy.Richtext"
          />
        </slot>
      </div>
    </LazyUiDialog>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  sizeGuideId?: string | null
}>()

const { public: config } = useRuntimeConfig()
const modalSizeGuide = useUiDialog('modal-size-guide')

const openSizeGuide = () => {
  modalSizeGuide.open()
}

const { data: copyData } = await useAsyncGraphqlQuery(
  'sizeGuide',
  computed(() => ({
    copyUid: props.sizeGuideId,
    locale: config.strapiLocale,
    status: 'PUBLISHED',
  })),
  {
    enabled: computed(() => !!props.sizeGuideId.value),
    transform: result => result.data,
    server: false,
  },
)

const sizeGuideCopy = computed(() => copyData.value?.copies?.[0]?.Richtexts)
</script>

<style>
@import url("~layers/app/components/Product/SizeGuide.css");
</style>
